import React from 'react';
import { useSelector } from 'react-redux';
import getCurrentCategory from 'store/category/selector/getCurrentCategory';
import styles from './CategorySeoText.module.scss';

const CategorySeoText = () => {
  const seoText = useSelector(getCurrentCategory)?.seoTextHtml || '';
  const seoHeader = useSelector(getCurrentCategory)?.seoHeader || '';
  return (
    <>
      <div className={styles.categoryHeader}>{seoHeader}</div>
      <div className={styles.categoryText} dangerouslySetInnerHTML={{ __html: seoText }} />
    </>
  );
};

export default CategorySeoText;
